import actionCreatorFactory from "typescript-fsa";
import { Dataset } from "./types";

const actionCreator = actionCreatorFactory("@@Dataset");

export const datasetActions = {
  fetchDatasets: actionCreator.async<{}, { datasets: Dataset[] }>("FETCH_DATASETS"),
  resetToInitialState: actionCreator("RESET_TO_INITIAL_STATE"),
};
